import { Button } from "@/nzds/inputs/button"
import type { TFunction } from "i18next"

import { ArrowForwardRounded } from "@mui/icons-material"
import type { GridColDef } from "@mui/x-data-grid-pro"

import { ConfidenceChip, DetectorTag } from "../homepage/atoms"
import type { ActionRow } from "./actions.types"

export interface ActionColumnsOptions {
  /** Currency formatter from `useFormatCurrency`. */
  formatCurrency: (value: number) => string
  /** Navigate to the detector leaf for a row. */
  onReview: (row: ActionRow) => void
  /** Translator for the `common` namespace. */
  t: TFunction
}

export const actionColumns = ({
  formatCurrency,
  onReview,
  t,
}: ActionColumnsOptions): GridColDef<ActionRow>[] => [
  { field: "site_label", headerName: "Site", flex: 1.4, minWidth: 200 },
  {
    field: "detector_code",
    headerName: "Detector",
    width: 150,
    renderCell: (params) => <DetectorTag code={params.row.detector_code} />,
  },
  { field: "action_text", headerName: "Action", flex: 1.6, minWidth: 240 },
  {
    field: "impact_dollars",
    headerName: t("neat.observedLabel"),
    width: 150,
    type: "number",
    renderCell: (params) => formatCurrency(params.row.impact_dollars),
  },
  {
    field: "confidence",
    headerName: "Confidence",
    width: 140,
    renderCell: (params) => <ConfidenceChip level={params.row.confidence} />,
  },
  {
    field: "review",
    headerName: "",
    width: 130,
    sortable: false,
    filterable: false,
    align: "right",
    headerAlign: "right",
    renderCell: (params) => (
      <Button
        endIcon={<ArrowForwardRounded />}
        onClick={() => {
          onReview(params.row)
        }}
        size="small"
        variant="text"
      >
        Review
      </Button>
    ),
  },
]
